"use strict";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

Shopify.theme.jsAjaxCart = {
  init: function init($section) {
    // Add settings from schema to current object
    Shopify.theme.jsAjaxCart = $.extend(this, Shopify.theme.getSectionData($section));

    if (isScreenSizeLarge() || this.cart_action == 'drawer') {
      this.initializeAjaxCart();
    } else {
      this.initializeAjaxCartOnMobile();
    }

    if (this.cart_action == 'drawer') {
      this.ajaxCartDrawer = $('[data-ajax-cart-drawer]');
      $(document).on('click', '[data-ajax-cart-trigger]', function (e) {
        e.preventDefault();
        Shopify.theme.jsAjaxCart.showDrawer();
        return false;
      });
    } else if (this.cart_action == 'mini_cart') {
      this.showMiniCartOnHover();
    }

    $(document).on('click', '.ajax-submit', function (e) {
      e.preventDefault();
      if ($(this).hasClass('customize_button_addtocart')) {
        return
      }
      var $addToCartForm = $(this).closest('form');
      Shopify.theme.jsAjaxCart.addToCart($addToCartForm);
      return false;
    });
    $(document).on('click', '[data-ajax-cart-delete]', function (e) {
      e.preventDefault();
      var lineID = $(this).parents('[data-line-item]').data('line-item');
      Shopify.theme.jsAjaxCart.removeFromCart(lineID);

      if (Shopify.theme.jsCart) {
        Shopify.theme.jsCart.removeFromCart(lineID);
      }

      return false;
    });
    $(document).on('click', '[data-ajax-cart-close]', function (e) {
      e.preventDefault();
      Shopify.theme.jsAjaxCart.hideDrawer();
      Shopify.theme.jsAjaxCart.hideMiniCart();
      return false;
    });
  },
  showMiniCartOnHover: function showMiniCartOnHover() {
    var $el = $('[data-ajax-cart-trigger]');
    $el.hover(function () {
      if (Shopify.theme_settings.header_layout == 'centered' && $('.header-sticky-wrapper').hasClass('is-sticky')) {
        $('.header-sticky-wrapper [data-ajax-cart-trigger]').addClass('show-mini-cart');
      } else {
        $el.addClass('show-mini-cart');
      }
    }, function () {
      $el.removeClass('show-mini-cart');
    });
  },
  hideMiniCart: function hideMiniCart() {
    if (this.cart_action != 'mini_cart') return false;
    var $el = $('[data-ajax-cart-close]').parents('[data-ajax-cart-trigger]');
    $el.removeClass('show-mini-cart');
  },
  toggleMiniCart: function toggleMiniCart() {
    var $el = $('.mobile-header [data-ajax-cart-trigger]'); // Removes url to the cart page so user is not redirected

    $el.attr('href', '#');
    $el.off('click').on('click', function (e) {
      // If user clicks inside the element, do nothing
      if (e.target.closest('[data-ajax-cart-mini_cart]')) {
        return;
      } // Loads content into ajaxCart container for mobile header


      Shopify.theme.jsAjaxCart.initializeAjaxCartOnMobile(); // If user clicks outside the element, toggle the mini cart

      $el.toggleClass('show-mini-cart'); // Calculate height of mini cart

      var announcementHeight = 0;
      var mobileHeaderHeight = parseInt($('.mobile-header').height());

      if (typeof Shopify.theme.jsAnnouncementBar !== 'undefined' && Shopify.theme.jsAnnouncementBar.enable_sticky) {
        announcementHeight = Shopify.theme.jsAnnouncementBar.getAnnouncementHeight();
      }

      $('.mobile-header .theme-ajax-cart').css({
        height: "calc(100vh - ".concat(mobileHeaderHeight + announcementHeight, "px)")
      });
    });
  },
  showDrawer: function showDrawer() {
    if (this.cart_action != 'drawer') {
      return false
    }
    window.dataLayer.push({'event': 'cart_recommend'})
    if (!this.ajaxCartDrawer.hasClass('is-visible') 
        && this.ajaxCartDrawer.hasClass('cart-recomd-enabled')
        && this.ajaxCartDrawer.data('is-recomnd-mode')) {
      this.getRecomdData()
    }
    this.ajaxCartDrawer.addClass('is-visible');
    $('.ajax-cart__overlay').addClass('is-visible');
    $('html').addClass('drawer-cart-opened')
  },
  hideDrawer: function hideDrawer() {
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.removeClass('is-visible');
    $('.ajax-cart__overlay').removeClass('is-visible');
    $('html').removeClass('drawer-cart-opened')
  },
  removeFromCart: function removeFromCart(lineID, callback) {
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&line=' + lineID,
      dataType: 'json',
      success: function success(cart) {
        window.dataLayerData.cartItems = cart.items
        Shopify.theme.jsAjaxCart.updateView();
      },
      error: function error(XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
        if (Shopify.theme.Sentry) {
          Shopify.theme.Sentry.updateCartError('quantity=0&line=' + lineID, XMLHttpRequest.responseText)
        }
      }
    });
  },
  initializeAjaxCart: function initializeAjaxCart() {
    const _this = this
    Shopify.theme.asyncView.load(Shopify.routes.cart_url, // template name
      'ajax' // view name (suffix)
    ).then(function (_ref) {
      var html = _ref.html,
        options = _ref.options;
      $('[data-ajax-cart-content]').html(html.content); // Converting the currencies

      if (Currency.show_multiple_currencies) {
        Shopify.theme.currencyConverter.convertCurrencies();
      }

      // Locate discount box
      if (!jQuery('#shopify-section-cart__main').length) {
        jQuery('body>.theme-ajax-cart .ajax-cart__subtotal').after('<noscript class="tdfPlaceDiscounts"></noscript>');
      }

      _this.autoApplyCode()

    }).catch(function () {// some error handling
    });
  },
  initializeAjaxCartOnMobile: function initializeAjaxCartOnMobile() {
    const _this = this
    this.toggleMiniCart();
    Shopify.theme.asyncView.load(Shopify.routes.cart_url, // template name
      'ajax' // view name (suffix)
    ).then(function (_ref2) {
      var html = _ref2.html,
        options = _ref2.options;
      $('.mobile-header [data-ajax-cart-content]').html(html.content);

      _this.autoApplyCode()

    }).catch(function () {// some error handling
    });
  },
  addToCart: function addToCart($addToCartForm) {
    var $addToCartBtn = $addToCartForm.find('.button--add-to-cart');
    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: $addToCartForm.serialize(),
      beforeSend: function beforeSend() {
        $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
        $addToCartBtn.find('span').removeClass("fadeInDown").addClass('animated zoomOut');
      },
      success: function success(product) {
        window.dataLayerData.cartItems.push(product);
        var $el = $('[data-ajax-cart-trigger]');
        $addToCartBtn.find('.checkmark').addClass('checkmark-active');

        function addedToCart() {
          if (!isScreenSizeLarge()) {
            $el = $('.mobile-header [data-ajax-cart-trigger]');
            Shopify.theme.scrollToTop($el);
          } else {
            $el = $('[data-ajax-cart-trigger]');
          }

          $el.addClass('show-mini-cart');
          $addToCartBtn.find('span').removeClass('fadeInDown');
        }

        window.setTimeout(function () {
          $addToCartBtn.removeAttr('disabled').removeClass('disabled');
          $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
          $addToCartBtn.find('.text, .icon').removeClass('zoomOut').addClass('fadeInDown');
          $addToCartBtn.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', addedToCart);
        }, 1000);
        Shopify.theme.jsAjaxCart.showDrawer();
        Shopify.theme.jsAjaxCart.updateView();

        if (Shopify.theme.jsCart) {
          var _$$ajax;

          $.ajax((_$$ajax = {
            dataType: "json",
            async: false,
            cache: false
          }, _defineProperty(_$$ajax, "dataType", 'html'), _defineProperty(_$$ajax, "url", "/cart"), _defineProperty(_$$ajax, "success", function success(html) {
            var cartForm = $(html).find('.cart__form');
            $('.cart__form').replaceWith(cartForm);
          }), _$$ajax));
        }
      },
      error: function error(XMLHttpRequest) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
        var cartWarning = "<p class=\"cart-warning__message animated bounceIn\">".concat(response.replace('All 1 ', 'All '), "</p>");
        $('.warning').remove();
        $addToCartForm.find('.cart-warning').html(cartWarning);
        $addToCartBtn.removeAttr('disabled').removeClass('disabled');
        $addToCartBtn.find('.icon').removeClass('zoomOut').addClass('zoomIn');
        $addToCartBtn.find('.text').text(Shopify.translation.addToCart).removeClass('zoomOut').addClass('zoomIn');

        if (Shopify.theme.Sentry) {
          Shopify.theme.Sentry.addToCartError($addToCartForm.serialize(), XMLHttpRequest.responseText)
        }
      }
    });
  },
  updateView: function updateView(onSuccess, onError, onComplete) {
    Shopify.theme.asyncView.load(Shopify.routes.cart_url, // template name
      'ajax' // view name (suffix)
    ).then((_ref3) => {
      var html = _ref3.html,
        options = _ref3.options;

      if (options.item_count > 0) {
        var itemList = $(html.content).find('.ajax-cart__list');
        var cartDetails = $(html.content).find('.ajax-cart__details-wrapper');
        $('.ajax-cart__list').each(function() {
          $(this).replaceWith(itemList);
        })
        $('.ajax-cart__details-wrapper').each(function() {
          $(this).replaceWith(cartDetails)
        });
        $('.ajax-cart__empty-cart-message').addClass('is-hidden');
        $('.ajax-cart__content-wrap').removeClass('is-hidden');
        $('[data-ajax-cart-trigger]').addClass('has-cart-count');
        $('[data-bind="itemCount"]').text(options.item_count);
      } else {
        $('.ajax-cart__empty-cart-message').removeClass('is-hidden');
        $('.ajax-cart__content-wrap').addClass('is-hidden');
        $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
        $('[data-bind="itemCount"]').text('0');
        this.ajaxCartDrawer.removeClass('show-cart-recomd')
      }

      if (Currency.show_multiple_currencies) {
        Shopify.theme.currencyConverter.convertCurrencies();
      }

      // Locate discount box
      if (!jQuery('#shopify-section-cart__main').length) {
        jQuery('body>.theme-ajax-cart .ajax-cart__subtotal').after('<noscript class="tdfPlaceDiscounts"></noscript>');
      }

      this.autoApplyCode()

      requestAnimationFrame(function () {
        if (onSuccess) {
          onSuccess()
        }
        if (onComplete) {
          onComplete()
        }
      })
    }).catch(function () {// some error handling
      if (onError) {
        onError()
      }
      if (onComplete) {
        onComplete()
      }
    });
  },
  unload: function unload($section) {
    // Clear event listeners in theme editor
    $('.ajax-submit').off();
    $('[data-ajax-cart-delete]').off();
  },
  addToCart_CustomBar: function addToCart_CustomBar($addToCartForm) {
    var $addToCartBtn = $addToCartForm.find('.button--add-to-cart');
    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: $addToCartForm.serialize(),
      beforeSend: function beforeSend() {
        $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
        $addToCartBtn.find('span').removeClass("fadeInDown").addClass('animated zoomOut');
      },
      success: function success(product) {
        window.dataLayerData.cartItems.push(product);
        var $el = $('[data-ajax-cart-trigger]');
        $addToCartBtn.find('.checkmark').addClass('checkmark-active');

        function addedToCart() {
          if (!isScreenSizeLarge()) {
            $el = $('.mobile-header [data-ajax-cart-trigger]');
            //Shopify.theme.scrollToTop($el);
          } else {
            $el = $('[data-ajax-cart-trigger]');
          }

          $el.addClass('show-mini-cart');
          $addToCartBtn.find('span').removeClass('fadeInDown');
        }

        window.setTimeout(function () {
          $addToCartBtn.removeAttr('disabled').removeClass('disabled');
          $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
          $addToCartBtn.find('.text, .icon').removeClass('zoomOut').addClass('fadeInDown');
          $addToCartBtn.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', addedToCart);
        }, 1000);
        Shopify.theme.jsAjaxCart.showDrawer();
        Shopify.theme.jsAjaxCart.updateView();

        if (Shopify.theme.jsCart) {
          var _$$ajax;

          $.ajax((_$$ajax = {
            dataType: "json",
            async: false,
            cache: false
          }, _defineProperty(_$$ajax, "dataType", 'html'), _defineProperty(_$$ajax, "url", "/cart"), _defineProperty(_$$ajax, "success", function success(html) {
            var cartForm = $(html).find('.cart__form');
            $('.cart__form').replaceWith(cartForm);
          }), _$$ajax));
        }
      },
      error: function error(XMLHttpRequest) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
        var cartWarning = "<p class=\"cart-warning__message animated bounceIn\">".concat(response.replace('All 1 ', 'All '), "</p>");
        $('.warning').remove();
        $addToCartForm.find('.cart-warning').html(cartWarning);
        $addToCartBtn.removeAttr('disabled').removeClass('disabled');
        $addToCartBtn.find('.icon').removeClass('zoomOut').addClass('zoomIn');
        $addToCartBtn.find('.text').text(Shopify.translation.addToCart).removeClass('zoomOut').addClass('zoomIn');

        if (Shopify.theme.Sentry) {
          Shopify.theme.Sentry.addToCartError($addToCartForm.serialize(), XMLHttpRequest.responseText)
        }
      }
    });
  },
  getFilterSkus() {
    const skus = []

    this.ajaxCartDrawer.find('.ajax-cart__product').each(function () {
      const sku = $(this).data('sku')
      skus.push(sku)
    })

    return skus.join(',')
  },
  getRecomdData() {
    const skus = $('.ajax-cart__product').eq(0).data('sku')

    if (!skus) {
      this.ajaxCartDrawer.removeClass('show-cart-recomd')
      return
    }

    const filterSkus = this.getFilterSkus()
    const params = {
      shopify_domain: Shopify.shop,
      skus,
      limit: 5,
      filter_skus: filterSkus
    }

    function getUserId() {
      if (window.ga) {
        return new Promise((resolve) => {
          window.ga(function (tracker) {
            resolve(tracker.get("clientId"))
          })
        })
      }
      return Promise.resolve("")
    }

    getUserId().then((userId) => {
      if (userId) {
        params.user_id = userId
      }
      $.ajax({
        url: `/apps/pp/rainbowbridge/personalize/relation`,
        dataType: 'json',
        cache: false,
        type: 'get',
        data: params,
        success: ({ data }) => {
          const recomdData = []
          let elements = []
          const trackSkus = []
          const trackList = []
          for (const item in data) {
            recomdData.push(...data[item])
          }
  
          if (recomdData.length) {
            recomdData.forEach((item, index) => {
              elements.push(this.getRecomdItem(item, index + 1, filterSkus))
  
              trackSkus.push(item.sku)
              trackList.push({
                "item_id": item.sku, //读取被推荐产品的SKU
                "item_name": item.product_title,
                "item_variant": item.variant_title,
                "price": item.variant_price,//读取被推荐产品展示的折扣价
                "index": index + 1 //读取被推荐的位置，如1,2,3
              })
            })
  
            this.ajaxCartDrawer.addClass('show-cart-recomd')
  
            setTimeout(() => {
              $('.ajax-cart__recomd-list').empty().append(elements)
              requestAnimationFrame(() => {
                $('.ajax-cart__recomd-wrap').addClass('show')
              })
            }, 300)
  
            window.dataLayer.push({ "event_parameters": null });
            window.dataLayer.push({
              "event": "ga4Event",
              "event_name": "view_item_list",
              "event_parameters": {
                "page_group": `Cart Pop Up_${filterSkus || skus}`, //取侧边栏购物车内的原本的所有SKU
                "item_list_name": "Cart Pop Up_Bundle",
                "items": trackList
              }
            });
          }
        }
      })
    })
  },
  getRecomdItem(item, index, filterSkus) {
    const el = $(`<li class="ajax-cart__recomd-item"  data-variant-item="${item.variant_shopify_id}">
      <div class="ajax-cart__recomd-item-content">
        <div class="c__recomd-item-img">
          <a class="js-cart-recomd-link" data-type="image" href="/products/${item.handle}?variant=${item.variant_shopify_id}">
            <img src="${item.variant_image}">
          </a>
        </div>
        <div class="c__recomd-item-info">
          <p class="c__recomd-item-title"><a class="js-cart-recomd-link" data-type="title" href="/products/${item.handle}?variant=${item.variant_shopify_id}">${item.product_title}</a></p>
          <p class="c__recomd-item-variant">${item.variant_title}</p>
          <p class="c__recomd-item-ctn">
            <span class="c__recomd-item-price">${item.currency_symbol}${item.variant_price}</span>
            <button class="button c__recomd-item-button js-cart-recomd-btn button--primary" data-v-id="${item.variant_shopify_id}"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true" class="w-4 h-4 inline-block"><path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4"></path></svg>Add</button>
          </p>
        </div>
      </div>
    </li>`)

    const _this = this
    el.find('.js-cart-recomd-btn').click(function (e) {
      e.preventDefault()
      const id = item.variant_shopify_id

      const lineItems = handleProposalLineItems(
        [
          {
            id,
            quantity: 1,
          },
        ],
        { customerEmail: $('.ajax-cart__content-wrap').data().logined }
      )
      Shopify.theme.addItemsToCart(lineItems, {
        onError: err => $.dialog({ title: err.message, content: err.description, type: 'red' })
      })

      $(`[data-variant-item="${id}"]`).remove()

      if ($('.ajax-cart__recomd-item').length === 0) {
        _this.ajaxCartDrawer.removeClass('show-cart-recomd')
      }

      window.dataLayer.push({ "event_parameters": null });
      window.dataLayer.push({
        "event": "ga4Event",
        "event_name": "add_to_cart",
        "event_parameters": {
          "page_group": `Cart Pop Up_${filterSkus}`, //取侧边栏购物车内的原本的所有SKU
          "item_list_name": "Cart Pop Up_add_Bundle",
          "currency": item.currency,
          "value": item.variant_price,
          "items": [{
            "item_id": item.sku, //读取被推荐产品的SKU
            "item_name": item.product_title,
            "item_brand": 'soundcore',
            "item_variant": item.variant_title,
            "price": item.variant_price,
            "quantity": 1
          }]//取点击推荐产品的信息
        }
      })
    })
    el.find('.js-cart-recomd-link').click(function (e) {
      const type = $(this).data('type')

      window.dataLayer.push({ "event_parameters": null });
      window.dataLayer.push({
        "event": "ga4Event",
        "event_name": "select_item",
        "event_parameters": {
          "page_group": `Cart Pop Up_${filterSkus}`, //取侧边栏购物车内的原本的所有SKU
          "action": type,
          "item_list_name": `Cart Pop Up_Bundle`,
          "items": [{
            "item_id": item.sku, //读取点击的产品SKU
            "item_name": item.product_title, //产品名
            "item_variant": item.variant_title, 
            "price": item.variant_price, //读取price,无价格则空
            "index": index //读取被推荐的位置，如1,2,3,4,5
          }]
        }
      })
    })

    return el
  },
  autoApplyCode() {
    // 自动应用折扣
    const cartDiscountCode = sessionStorage.getItem('cart_discount_code')
    if ($('#cart-discount').length && cartDiscountCode) {
      const codeData = JSON.parse(cartDiscountCode)
      if (codeData.skus) {
        let codeShouldApply = {}

        $('.ajax-cart .ajax-cart__product[data-sku]').each(function() {
          if (codeData.skus.includes($(this).data('sku'))) {
            codeShouldApply[$(this).data('sku')] = true
          }
        })

        if (Object.values(codeShouldApply).length === codeData.skus.length) { 
          $('.ajax-cart .ajax-cart__details-wrapper #cart-discount').val(codeData.code)
        }
      }
    }
  }
};